import classNames from "../../../../classNames";

const FormField = ({ label, required, className, children, sublabel }) => (
  <div className={classNames("d-flex flex-column w-100", className)}>
    <div className="d-flex gap-2">
      <p className="m-0 fw-bold text-muted small">{label}</p>{" "}
      {required && <b className="text-danger">*</b>}
    </div>
    {children}
    <i className="m-0" style={{ fontSize: "0.75rem" }}>
      {sublabel}
    </i>
  </div>
);

export default FormField;
